(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-thumb-row"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__nofltrsVideoRailV4) return;
  window.__nofltrsVideoRailV4 = true;

  var thumbObserver = null;

  function mediaFor(video) {
    return video
      ? video.closest('[data-vtr-media]')
      : null;
  }

  function playButtonFor(video) {
    var media = mediaFor(video);

    return media
      ? media.querySelector('[data-vtr-play]')
      : null;
  }

  function muteButtonFor(video) {
    var media = mediaFor(video);

    return media
      ? media.querySelector('[data-vtr-mute]')
      : null;
  }

  function setPlaying(video, playing) {
    var media = mediaFor(video);
    var button = playButtonFor(video);

    if (media) {
      media.classList.toggle('is-playing', playing);
    }

    if (button) {
      button.setAttribute(
        'aria-label',
        playing ? 'Pause video' : 'Play video'
      );

      button.setAttribute(
        'aria-pressed',
        playing ? 'true' : 'false'
      );
    }
  }

  function updateMute(video) {
    var button = muteButtonFor(video);

    if (!button) return;

    var muted =
      video.muted ||
      video.volume === 0;

    button.classList.toggle('is-muted', muted);

    button.setAttribute(
      'aria-pressed',
      muted ? 'true' : 'false'
    );

    button.setAttribute(
      'aria-label',
      muted ? 'Unmute video' : 'Mute video'
    );
  }

  function pauseOthers(video) {
    var row = video.closest('[data-video-thumb-row]');

    if (!row) return;

    row
      .querySelectorAll('[data-vtr-video]')
      .forEach(function (other) {
        if (
          other !== video &&
          !other.paused
        ) {
          other.pause();
        }
      });
  }

  function toggleVideo(video) {
    if (!video) return;

    if (
      video.paused ||
      video.ended
    ) {
      if (video.ended) {
        try {
          video.currentTime = 0;
        } catch (error) {}
      }

      video.dataset.vtrPlayed = 'true';

      var promise = video.play();

      if (
        promise &&
        typeof promise.catch === 'function'
      ) {
        promise.catch(function () {});
      }

    } else {
      video.pause();
    }
  }

  function finishAutoThumbnail(video) {
    if (
      video.dataset.vtrThumbReady === 'true'
    ) {
      return;
    }

    video.dataset.vtrThumbReady = 'true';

    var media = mediaFor(video);

    if (media) {
      media.classList.remove('is-thumb-loading');
      media.classList.add('has-auto-thumbnail');
    }

    video.pause();
  }

  function generateAutoThumbnail(video) {
    if (!video) return;

    if (
      video.dataset.vtrThumbLoading === 'true' ||
      video.dataset.vtrThumbReady === 'true' ||
      video.dataset.autoThumbnail !== 'true' ||
      video.hasAttribute('poster')
    ) {
      return;
    }

    video.dataset.vtrThumbLoading = 'true';

    var media = mediaFor(video);

    if (media) {
      media.classList.add('is-thumb-loading');
    }

    var requestedTime =
      parseFloat(
        video.dataset.thumbnailTime || '0.2'
      );

    function seek() {
      var target = requestedTime;

      if (
        Number.isFinite(video.duration) &&
        video.duration > 0
      ) {
        target = Math.min(
          requestedTime,
          Math.max(
            0.01,
            video.duration - 0.05
          )
        );
      }

      if (target <= 0) {
        target = 0.01;
      }

      try {
        video.currentTime = target;
      } catch (error) {}
    }

    video.addEventListener(
      'loadedmetadata',
      seek,
      { once: true }
    );

    video.addEventListener(
      'seeked',
      function () {
        finishAutoThumbnail(video);
      },
      { once: true }
    );

    video.addEventListener(
      'loadeddata',
      function () {
        window.setTimeout(function () {
          if (
            video.dataset.vtrThumbReady !== 'true'
          ) {
            finishAutoThumbnail(video);
          }
        }, 150);
      },
      { once: true }
    );

    video.preload = 'metadata';

    try {
      video.load();
    } catch (error) {}
  }

  function getThumbObserver() {
    if (thumbObserver) {
      return thumbObserver;
    }

    if (!('IntersectionObserver' in window)) {
      return null;
    }

    thumbObserver =
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            thumbObserver.unobserve(
              entry.target
            );

            generateAutoThumbnail(
              entry.target
            );
          });
        },
        {
          rootMargin: '300px 0px',
          threshold: 0.01
        }
      );

    return thumbObserver;
  }

  function initVideo(video) {
    if (
      !video ||
      video.dataset.vtrInitialized === 'true'
    ) {
      return;
    }

    video.dataset.vtrInitialized = 'true';

    updateMute(video);
    setPlaying(video, false);

    video.addEventListener(
      'play',
      function () {
        pauseOthers(video);
        setPlaying(video, true);
      }
    );

    video.addEventListener(
      'pause',
      function () {
        setPlaying(video, false);
      }
    );

    video.addEventListener(
      'ended',
      function () {
        setPlaying(video, false);

        var button =
          playButtonFor(video);

        if (button) {
          button.setAttribute(
            'aria-label',
            'Replay video'
          );
        }
      }
    );

    video.addEventListener(
      'volumechange',
      function () {
        updateMute(video);
      }
    );

    if (
      video.dataset.autoThumbnail === 'true' &&
      !video.hasAttribute('poster')
    ) {
      var observer =
        getThumbObserver();

      if (observer) {
        observer.observe(video);
      } else {
        generateAutoThumbnail(video);
      }
    }
  }

  function getScrollStep(scroller) {
    var first =
      scroller.children[0];

    if (!first) {
      return scroller.clientWidth;
    }

    var width =
      first.getBoundingClientRect().width;

    var styles =
      window.getComputedStyle(scroller);

    var gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        '0'
      );

    return width + gap;
  }

  /*
   * Updates:
   * - desktop arrows
   * - overflow detection
   * - mobile progress indicator
   * - left/right direction cue
   */
  function updateRail(row) {
    if (!row) return;

    var scroller =
      row.querySelector(
        '[data-vtr-scroller]'
      );

    if (!scroller) return;

    var prev =
      row.querySelector('[data-vtr-prev]');

    var next =
      row.querySelector('[data-vtr-next]');

    var progressThumb =
      row.querySelector(
        '[data-vtr-progress-thumb]'
      );

    var max =
      Math.max(
        0,
        scroller.scrollWidth -
        scroller.clientWidth
      );

    var overflow =
      max > 3;

    var alreadyOverflow =
      row.classList.contains(
        'has-overflow'
      );

    row.classList.toggle(
      'has-overflow',
      overflow
    );

    /*
     * Adding the overflow class changes mobile card
     * widths to expose the next-card peek.
     * Recalculate once after that layout change.
     */
    if (
      alreadyOverflow !== overflow
    ) {
      window.requestAnimationFrame(
        function () {
          updateRail(row);
        }
      );
    }

    var atStart =
      scroller.scrollLeft <= 3;

    var atEnd =
      !overflow ||
      scroller.scrollLeft >= max - 3;

    row.classList.toggle(
      'is-at-start',
      atStart
    );

    row.classList.toggle(
      'is-at-end',
      atEnd
    );

    if (prev) {
      prev.disabled =
        !overflow ||
        atStart;
    }

    if (next) {
      next.disabled =
        !overflow ||
        atEnd;
    }

    /*
     * Native-style mini scrollbar.
     *
     * Thumb width represents how much of the
     * total carousel is currently visible.
     *
     * Thumb position represents current position.
     */
    if (
      progressThumb &&
      scroller.scrollWidth > 0
    ) {
      var visibleRatio =
        scroller.clientWidth /
        scroller.scrollWidth;

      visibleRatio =
        Math.min(
          1,
          Math.max(
            0.08,
            visibleRatio
          )
        );

      var thumbWidth =
        visibleRatio * 100;

      var position =
        scroller.scrollLeft /
        scroller.scrollWidth *
        100;

      position =
        Math.max(
          0,
          Math.min(
            100 - thumbWidth,
            position
          )
        );

      progressThumb.style.width =
        thumbWidth + '%';

      progressThumb.style.left =
        position + '%';
    }
  }

  function initScroller(scroller) {
    if (
      !scroller ||
      scroller.dataset.vtrScrollerReady === 'true'
    ) {
      return;
    }

    scroller.dataset.vtrScrollerReady =
      'true';

    var row =
      scroller.closest(
        '[data-video-thumb-row]'
      );

    if (!row) return;

    var prev =
      row.querySelector('[data-vtr-prev]');

    var next =
      row.querySelector('[data-vtr-next]');

    if (prev) {
      prev.addEventListener(
        'click',
        function () {
          scroller.scrollBy({
            left:
              -getScrollStep(scroller),
            behavior: 'smooth'
          });
        }
      );
    }

    if (next) {
      next.addEventListener(
        'click',
        function () {
          scroller.scrollBy({
            left:
              getScrollStep(scroller),
            behavior: 'smooth'
          });
        }
      );
    }

    scroller.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(
          function () {
            updateRail(row);
          }
        );
      },
      { passive: true }
    );

    scroller.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();

          scroller.scrollBy({
            left:
              getScrollStep(scroller),
            behavior: 'smooth'
          });
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();

          scroller.scrollBy({
            left:
              -getScrollStep(scroller),
            behavior: 'smooth'
          });
        }
      }
    );

    /*
     * Desktop mouse drag.
     * Touch stays native.
     */
    if (
      row.dataset.desktopDrag === 'true'
    ) {
      var pressed = false;
      var dragging = false;

      var startX = 0;
      var startScroll = 0;
      var pointerId = null;

      scroller.addEventListener(
        'pointerdown',
        function (event) {
          if (
            event.pointerType !== 'mouse'
          ) {
            return;
          }

          if (event.button !== 0) {
            return;
          }

          if (
            event.target.closest(
              '[data-vtr-play], [data-vtr-mute], .video-thumb-row__arrow'
            )
          ) {
            return;
          }

          pressed = true;
          dragging = false;

          startX = event.clientX;
          startScroll =
            scroller.scrollLeft;

          pointerId =
            event.pointerId;
        }
      );

      scroller.addEventListener(
        'pointermove',
        function (event) {
          if (!pressed) return;

          if (
            event.pointerId !== pointerId
          ) {
            return;
          }

          var distance =
            event.clientX - startX;

          if (
            !dragging &&
            Math.abs(distance) > 4
          ) {
            dragging = true;

            scroller.classList.add(
              'is-dragging'
            );

            try {
              scroller.setPointerCapture(
                event.pointerId
              );
            } catch (error) {}
          }

          if (dragging) {
            scroller.scrollLeft =
              startScroll - distance;

            event.preventDefault();
          }
        }
      );

      function finishDrag(event) {
        if (!pressed) return;

        pressed = false;

        if (dragging) {
          scroller.dataset.vtrJustDragged =
            'true';

          window.setTimeout(
            function () {
              delete scroller.dataset
                .vtrJustDragged;
            },
            180
          );
        }

        dragging = false;

        scroller.classList.remove(
          'is-dragging'
        );

        if (
          event &&
          pointerId !== null
        ) {
          try {
            scroller.releasePointerCapture(
              pointerId
            );
          } catch (error) {}
        }

        pointerId = null;
      }

      scroller.addEventListener(
        'pointerup',
        finishDrag
      );

      scroller.addEventListener(
        'pointercancel',
        finishDrag
      );
    }

    /*
     * Keep the indicator correct if Horizon changes
     * the width of the block in the theme editor.
     */
    if ('ResizeObserver' in window) {
      var resizeObserver =
        new ResizeObserver(
          function () {
            updateRail(row);
          }
        );

      resizeObserver.observe(scroller);
    }

    updateRail(row);

    window.requestAnimationFrame(
      function () {
        updateRail(row);
      }
    );
  }

  function init(root) {
    var scope = root || document;

    if (
      scope.matches &&
      scope.matches('[data-vtr-video]')
    ) {
      initVideo(scope);
    }

    if (
      scope.matches &&
      scope.matches(
        '[data-vtr-scroller]'
      )
    ) {
      initScroller(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(
          '[data-vtr-video]'
        )
        .forEach(initVideo);

      scope
        .querySelectorAll(
          '[data-vtr-scroller]'
        )
        .forEach(initScroller);

      scope
        .querySelectorAll(
          '[data-video-thumb-row]'
        )
        .forEach(updateRail);
    }
  }

  document.addEventListener(
    'click',
    function (event) {

      var playButton =
        event.target.closest(
          '[data-vtr-play]'
        );

      if (playButton) {
        event.preventDefault();
        event.stopPropagation();

        var playMedia =
          playButton.closest(
            '[data-vtr-media]'
          );

        var playVideo =
          playMedia
            ? playMedia.querySelector(
                '[data-vtr-video]'
              )
            : null;

        toggleVideo(playVideo);
        return;
      }

      var muteButton =
        event.target.closest(
          '[data-vtr-mute]'
        );

      if (muteButton) {
        event.preventDefault();
        event.stopPropagation();

        var muteMedia =
          muteButton.closest(
            '[data-vtr-media]'
          );

        var muteVideo =
          muteMedia
            ? muteMedia.querySelector(
                '[data-vtr-video]'
              )
            : null;

        if (muteVideo) {
          muteVideo.muted =
            !muteVideo.muted;
        }

        return;
      }

      var media =
        event.target.closest(
          '[data-vtr-media]'
        );

      if (!media) return;

      var scroller =
        media.closest(
          '[data-vtr-scroller]'
        );

      if (
        scroller &&
        scroller.dataset.vtrJustDragged ===
          'true'
      ) {
        return;
      }

      var video =
        media.querySelector(
          '[data-vtr-video]'
        );

      if (
        video &&
        !video.paused
      ) {
        toggleVideo(video);
      }
    }
  );

  window.addEventListener(
    'resize',
    function () {
      document
        .querySelectorAll(
          '[data-video-thumb-row]'
        )
        .forEach(updateRail);
    },
    { passive: true }
  );

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      }
    );
  } else {
    init(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(event.target);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    function (event) {
      init(event.target);
    }
  );

  var observer =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            mutation.addedNodes.forEach(
              function (node) {
                if (
                  node.nodeType === 1
                ) {
                  init(node);
                }
              }
            );
          }
        );
      }
    );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();
  } catch(e) { console.error(e); }
})();

})();
